import { render, staticRenderFns } from "./AdminTickets.vue?vue&type=template&id=4671970b&scoped=true&"
import script from "./AdminTickets.vue?vue&type=script&lang=js&"
export * from "./AdminTickets.vue?vue&type=script&lang=js&"
import style0 from "./AdminTickets.vue?vue&type=style&index=0&id=4671970b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4671970b",
  null
  
)

export default component.exports